import axios from '@/user/axios'

const moduleUserInvite = {
  namespaced: true,
  state: {
    userInvite: {},
    userInvites: []
  },
  mutations: {
    SET_USER_INVITE: (state, payload) => {
      state.userInvite = payload
    }
  },
  actions: {
    getUserInvite (context, payload) {
      return new Promise(async (resolve, reject) => {
        const { token } = payload
        axios.get(`/api/user-invite/${token}`)
          .then(resp => {
            context.commit('SET_USER_INVITE', resp.data.data)
            resolve(resp)
          }).catch(err => {
            reject(err)
          })
      })
    },
    deleteUserInvite (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const { token } = payload
          const res = await axios.delete(`/api/user-invite/${token}`)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    }
  }
}

export default moduleUserInvite
